import { render, staticRenderFns } from "./app-update-manage.vue?vue&type=template&id=8b0e59a2&scoped=true"
import script from "./app-update-manage.vue?vue&type=script&lang=js"
export * from "./app-update-manage.vue?vue&type=script&lang=js"
import style0 from "./app-update-manage.vue?vue&type=style&index=0&id=8b0e59a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0e59a2",
  null
  
)

export default component.exports